module.exports = Backbone.Model.extend({
	idAttribute: 'appId'
})
